import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { MsisdnService } from '../../shared/msisdn/msisdn.service';
import { FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { createUniqueLabelValidator } from '../../shared/msisdn/number-label.validator';
import { ErrorStateMatcher } from '@angular/material/core';
import { blankStringValidator } from '../../shared/validators/blank-string.validator';
import { fourByteStringValidator } from '../../shared/validators/four-byte-string.validator';
import { NotificationService } from '../../shared/notification.service';

export class LabelErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'cc-label-updater',
  templateUrl: './label-updater.component.html',
  styleUrls: ['./label-updater.component.scss']
})
export class LabelUpdaterComponent implements OnInit {
  @Input() msisdn;
  @Output() labelChange = new EventEmitter<string>();
  form: FormGroup;
  matcher = new LabelErrorStateMatcher();

  private savingMutex = false;

  constructor(
    private locationStrategy: LocationStrategy,
    private msisdnService: MsisdnService,
    private translateService: TranslateService,
    public notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    this.form = new FormGroup({
      label: new FormControl(this.msisdn.label, {
        validators: [Validators.required, blankStringValidator, Validators.maxLength(100), fourByteStringValidator],
        asyncValidators: createUniqueLabelValidator(this.msisdnService, this.msisdn.label.trim()),
        updateOn: 'change'
      })
    });
  }

  visibleNumber(): string {
    return this.msisdn && this.msisdn.msisdn ? this.msisdn.msisdn : this.translateService.instant('PENDING') + '...';
  }

  disableButton() {
    return (
      this.savingMutex ||
      this.form.hasError('unique', ['label']) ||
      this.form.hasError('required', ['label']) ||
      this.form.hasError('blank', ['label']) ||
      this.form.hasError('fourByteCharacter', ['label'])
    );
  }

  async onSubmit() {
    try {
      this.savingMutex = true;
      await this.msisdnService
        .updateLabel(this.msisdn.id, {
          label: (this.form.get('label').value as string).trim()
        })
        .toPromise();

      this.notificationService.open('SUCCESS_MSG');
    } catch (e) {
      this.notificationService.open(Array.isArray(e.error) ? e.error[0] : e.error);
    } finally {
      this.savingMutex = false;
    }
  }
}
